export default {
  addTagBtn: "新規タグの追加",
  saveBtn: "保存",
  columns: {
    id: "タグID",
    name: "タグ名",
    isActive: "効能",
    action: "アクション",
  },
  placeholder: {
    tagName: "タグ名を入力してください",
  },
  confirm: {
    delete: "このタグを削除しますか？",
  },
  notification: {
    deleteSuccess: "タグを削除しました。",
  },
  error: {
    duplicateTagName: "このタグ名が既に存在しています。別のタグ名を入力してください",
  },
}
